import React from 'react';
import { Icon } from './Icon.js';
export const IconRecordFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm0,14.5c-3.584,0-6.5-2.916-6.5-6.5S5.416,2.5,9,2.5s6.5,2.916,6.5,6.5-2.916,6.5-6.5,6.5Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "9", r: "5", fill: "currentColor" })));
};
//# sourceMappingURL=IconRecordFill18.js.map